module.exports = __webpack_public_path__ + "img/Warning.71a147f7.png";